import React, { useEffect, useState } from 'react';

import './AppleLoginButton.css';

// 환경변수 또는 기본값 (SSR에서 import.meta 사용 불가)
const APPLE_CLIENT_ID = (typeof process !== 'undefined' && process.env?.VITE_APPLE_CLIENT_ID)
    || 'com.fruitsfamily.webapp';

const AppleLogo = () => (
    <svg width="16" height="19" viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.3574 3.54785C9.73584 4.29932 8.69678 4.85596 7.87109 4.85596C7.76904 4.85596 7.67627 4.8374 7.62061 4.82812C7.61133 4.78174 7.5835 4.64258 7.5835 4.49414C7.5835 3.54785 8.06592 2.60156 8.59473 2.00781C9.25342 1.22852 10.3667 0.65332 11.2944 0.616211C11.313 0.718262 11.3223 0.848145 11.3223 0.978027C11.3223 1.92432 10.9233 2.86133 10.3574 3.54785ZM11.0068 5.05078C11.5264 5.05078 13.4097 5.10645 14.6436 6.87842C14.5322 6.96191 12.6675 8.01953 12.6675 10.376C12.6675 13.0942 15.0425 14.0684 15.1167 14.0869C15.1074 14.1519 14.7363 15.4043 13.8643 16.6938C13.0757 17.8164 12.25 18.9575 11.0068 18.9575C9.75439 18.9575 9.42969 18.2246 8.00098 18.2246C6.59082 18.2246 6.08984 18.9761 4.95801 18.9761C3.80762 18.9761 3.00977 17.9277 2.10059 16.6475C1.03369 15.1353 0.180176 12.7881 0.180176 10.5615C0.180176 6.99902 2.49951 5.10645 4.79102 5.10645C5.99707 5.10645 6.99902 5.89502 7.76904 5.89502C8.49268 5.89502 9.62451 5.05078 11.0068 5.05078Z" fill="white"/>
    </svg>
);

/**
 * AppleLoginButton
 * @returns {JSX.Element}
 * @constructor
 */
function AppleLoginButton() {
    const clientId = APPLE_CLIENT_ID;
    const [redirectUri, setRedirectUri] = useState('');

    useEffect(() => {
        const hostname = window.location.hostname;

        if (hostname === 'fruitsfamily.com') {
            setRedirectUri('https://fruitsfamily.com/auth/apple/complete');
        } else {
            setRedirectUri('https://staging.fruitsfamily.com/auth/apple/complete');
        }
    }, []);

    const appleLoginUrl = `https://appleid.apple.com/auth/authorize?client_id=${clientId}&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=code%20id_token`;

    const handleClick = () => {
        window.location.href = appleLoginUrl;
    };

    return <button onClick={handleClick} className='AppleLoginButton'>
        <AppleLogo />
        <div>Apple로 계속하기</div>
    </button>
}

export default AppleLoginButton;
